/**
 * Exportación CSV desde el frontend (sin endpoint backend).
 */

function escapeCsvCell(val) {
  const s = val == null ? '' : String(val)
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`
  return s
}

/**
 * @param {Array<Record<string, any>>} rows
 * @param {Array<{ key: string, label?: string }>} columns
 * @param {string} filename
 */
export function exportRowsToCsv(rows, columns, filename = 'export.csv') {
  const cols = (columns || []).filter(c => c && c.key && c.key !== 'actions')
  if (!cols.length) return

  const header = cols.map(c => escapeCsvCell(c.label || c.key)).join(',')
  const body = (rows || [])
    .map(row =>
      cols
        .map(c => {
          const raw = typeof c.value === 'function' ? c.value(row) : row[c.key]
          return escapeCsvCell(raw == null ? '' : raw)
        })
        .join(',')
    )
    .join('\n')

  const text = `${header}\n${body}`
  const blob = new Blob(['\ufeff' + text], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
  a.click()
  URL.revokeObjectURL(url)
}

/**
 * Descarga todas las páginas de un listado paginado WL.
 * @param {(perPage: number, page: number) => Promise<{ items: any[], total?: number }>} fetchPage
 * @param {number} [perPage=100]
 * @param {number} [maxPages=50]
 */
export async function fetchAllPaginatedPages(fetchPage, perPage = 100, maxPages = 50) {
  const all = []
  let page = 1
  let total = null

  while (page <= maxPages) {
    const res = await fetchPage(perPage, page)
    const items = (res && res.items) || []
    all.push(...items)
    if (total == null && res && res.total != null) total = res.total
    if (!items.length) break
    if (total != null && all.length >= total) break
    if (items.length < perPage) break
    page += 1
  }

  return all
}

export function csvFilename(prefix) {
  const d = new Date()
  const pad = n => String(n).padStart(2, '0')
  const stamp = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(
    d.getHours()
  )}${pad(d.getMinutes())}`
  return `${prefix}_${stamp}.csv`
}
